import type { Component } from "solid-js";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import { getUserStore } from "~/solidJs/entities/HeaderMain/models";
import { getWorkspacesStore } from "~/solidJs/entities/WorkspaceListEntity/models/wrokspaceListContext";
import { getIsSaveFunctionalityAvailable } from "~/solidJs/shared/helpers";
import { useSaveWorkspaceFeature } from "~/solidJs/shared/hooks/useSaveWorkspaceFeature";
import { openPricingPage } from "~/solidJs/shared/models/pageParams/pricingPageParams";
import { Button, type ButtonMainProps, type btnVariants } from "~/solidJs/shared/ui";

type LayoutSaveProjectFeature = {
	variant?: btnVariants;
	afterSaveCallback?: () => void;
} & ButtonMainProps<"button">;

export const LayoutSaveProjectFeature: Component<LayoutSaveProjectFeature> = (props) => {
	const saveFeautre = useSaveWorkspaceFeature({ afterSaveCallback: props.afterSaveCallback });

	const clickHandler = () => {
		EventAnalytics.saveWorkspaceBtnClick();
		const canSave = getIsSaveFunctionalityAvailable(getUserStore());
		if (!canSave) {
			openPricingPage({ source: "saveWorkspaceBtnClick" });
			return;
		}
		if (getWorkspacesStore().isOpenedByLink) return;
		saveFeautre.save();
	};

	return (
		<Button
			data-test={"save-workspace"}
			pending={saveFeautre.getIsPending()}
			disabled={saveFeautre.getIsDisabled()}
			onClick={clickHandler}
			{...props}
		>
			Save project
		</Button>
	);
};
